import enAuth from './locales/en/auth.json';
import enContacts from './locales/en/contacts.json';
import enMailbox from './locales/en/mailbox.json';
import enSettings from './locales/en/settings.json';
import enTasks from './locales/en/tasks.json';
import enTranslation from './locales/en/translation.json';
import plAuth from './locales/pl/auth.json';
import plContacts from './locales/pl/contacts.json';
import plMailbox from './locales/pl/mailbox.json';
import plSettings from './locales/pl/settings.json';
import plTasks from './locales/pl/tasks.json';
import plTranslation from './locales/pl/translation.json';

export const resources = {
  en: {
    auth: enAuth,
    contacts: enContacts,
    mailbox: enMailbox,
    settings: enSettings,
    tasks: enTasks,
    translation: enTranslation,
  },
  pl: {
    auth: plAuth,
    contacts: plContacts,
    mailbox: plMailbox,
    settings: plSettings,
    tasks: plTasks,
    translation: plTranslation,
  },
} as const;

export const defaultLanguage = 'pl';
